/* PlatformExplorerEntityLmrbComponent.js */

"use strict";
const GameEditor = require("@gluenetworks/game_editor");
const Registrations = require("../../../RegistrationNamespaces");
const Steve = require("@gluenetworks/steve_core").getInstance();
const _ = require("lodash");

class PlatformExplorerEntityLmrbComponent extends GameEditor {
    constructor(
        logger,
        di,
        editorLayout,
        userSession,
        LicenseRestriction,
        storageFactory,
        solutionManager,
        OsUpgradePlanPrefs
    ) {
        super(logger, di);

        this._editorLayout = editorLayout;
        this._userSession = userSession;
        this._activeOrgId = userSession.activeOrganization.id;
        this._licenseRestriction = LicenseRestriction;
        this._osImageServers = [];
        this._sitePaths = [];
        this._solutionManager = solutionManager;
        this._OsUpgradePlanPrefsEntity = OsUpgradePlanPrefs;
        this._isOSMSolutionAvailable = undefined;
        this._isCatalogEnable = undefined;
        this._storageFactory = storageFactory;
        this._openEditorFromUrl = false;
        this._openNetworkDiscoveryFromUrl = false;
        this._filterFromUrl = false;
        this._autoCapturePrefsEntity = undefined;
        this._vendorMap = undefined;
        this._typeBaseMap = undefined;
        this._hasSupportedOs = undefined;
        this._dataSyncConfigEntity = {};

        this._updateNameSpaces();

        this._registerDeviceExplorerListeners();

        const superRender = this.renderer.render;
        this.renderer.render = (args) => {
            return superRender.apply(this.renderer, args).then(() => {
                this.renderer._rootElem.classList.add("odm-os-platform-explorer-entity-lmrb");
                if (this.currentSolutionName === "data_explorer") {
                    this.renderer._rootElem.classList.add("data-explorer-lmrb");
                }
                return this.whenGameEditorStorageIsReady().then(() => {
                    const otherParams = _.get(Steve.router.getRouteDetails(), "rd", {});

                    if (otherParams.openEditor && !_.isEmpty(otherParams.selection)) {
                        this._openEditorFromUrl = {
                            open: otherParams.openEditor || false,
                            selectedIds: otherParams.selection,
                        };
                    }
                    if (!_.isEmpty(otherParams.filter) || !_.isUndefined(otherParams.filter)) {
                        this._filterFromUrl = true;
                    }

                    if (otherParams.openNetworkDiscovery && !_.isEmpty(otherParams.selection)) {
                        this._openNetworkDiscoveryFromUrl = {
                            open: otherParams.openNetworkDiscovery || false,
                            selectedIds: otherParams.selection,
                        };
                    }

                    if (this._LMRBLayout.state.bottom.dockletClicked === true) {
                        this._gameEditorData.setData(
                            this._LMRBLayout.state.bottom._state.openedPartId,
                            "currentExplorerView"
                        );
                        this._LMRBLayout.state.bottom.dockletClicked = undefined;
                    }
                    this._xDomeEnabled = Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled;
                    const currentView = this._whereToRedirect();
                    this._switchSolution(currentView);

                    return;
                });
            });
        };
    }

    _whereToRedirect() {
        let currentView = "";
        if (_.get(Steve.router.getRouteDetails(), "exp", false)) {
            let currentViewName = _.get(Steve.router.getRouteDetails(), "exp", "");

            if (this.currentSolutionName === "os_manager") {
                switch (currentViewName) {
                    case "plan":
                        currentView = Registrations.OS_PLAN_EXPLORER_LMRB;
                        break;
                    case "catalog":
                        currentView = Registrations.OS_CATALOG_EXPLORER_LMRB;
                        break;
                    case "iot_device":
                        currentView =
                            Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                                ? Registrations.OS_MANAGER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
                                : Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                    case "iotplan":
                        currentView =
                            Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                                ? Registrations.IOT_OS_PLAN_EXPLORER_LMRB
                                : Registrations.OS_PLAN_EXPLORER_LMRB;
                        break;
                    case "platform":
                        // Return empty to fall through to default case which shows the grid
                        currentView = "";
                        break;
                    default:
                        currentView = Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                }
            } else if (this.currentSolutionName === "config_drift") {
                switch (currentViewName) {
                    case "audit":
                        currentView = Registrations.AUDIT_POLICY_EXPLORER_LMRB;
                        break;
                    default:
                        currentView = Registrations.CONFIG_DRIFT_DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                }
            } else if (this.currentSolutionName === "data_explorer") {
                switch (currentViewName) {
                    case "template":
                        currentView = Registrations.DATA_EXPLORER_LMRB;
                        break;
                    case "iot_device":
                        currentView =
                            Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                                ? Registrations.DATA_EXPLORER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
                                : Registrations.DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                    default:
                        currentView = Registrations.DATA_EXPLORER_DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                }
            } else if (this.currentSolutionName === "device_manager") {
                switch (currentViewName) {
                    case "site":
                        currentView = Registrations.SITE_EXPLORER_ENTITY_LMRB;
                        break;
                    case "network_discovery":
                        currentView = Registrations.NETWORK_DISCOVERY_EXPLORER_ENTITY_LMRB;
                        break;
                    case "iot_device":
                        currentView =
                            Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                                ? Registrations.IOT_DEVICE_EXPLORER_ENTITY_LMRB
                                : Registrations.DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                    default:
                        currentView = Registrations.DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                }
            }

            // this._gameEditorData.setData(currentView, "currentExplorerView");
            // Steve.router.rollups({app: 'GameConsole', s: 'GameCenter', sln: 'OsManager'});
        }
        return currentView;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _updateNameSpaces(withUpdate) {
        let solutionDefinition = this._solutionManager.getActiveSolution();
        let gameEditorViews = _.get(solutionDefinition, "platformExplorer.viewNamespaces", []);
        let gameEditorActions = _.get(solutionDefinition, "platformExplorer.actionNamespaces", []);

        this.setNamespaceGlobs(gameEditorViews.concat(gameEditorActions), !withUpdate);
    }

    _updateActions(addList = [], removeList = []) {
        let _actions = [].concat(this._registeredActions, addList);
        _actions = _actions.filter((action) => {
            if (removeList.indexOf(action.fullyQualifiedName) >= 0) {
                return false;
            }
            return true;
        });
        this.registerActions(_actions);
    }

    _registerDeviceExplorerListeners() {
        this._unregisterDeviceExplorerListeners();
        this._solutionManager.on(
            "activeSolutionChanged",
            (this._onSolutionChanged = this._onSolutionChanged.bind(this))
        );
        this._userSession.on(
            "OrganizationChange",
            (this._onOrganizationChange = this._onOrganizationChange.bind(this))
        );
        this._editorLayout.on(
            "EditorClosed",
            (this._onEditorClosed = this._onEditorClosed.bind(this))
        );
        this._editorLayout.on("ActiveTabChanged", this._onActiveTabChanged.bind(this));

        Steve.router.on(
            "RouteDetailsChanged",
            (this._onRouteInfoChanged = _.throttle(this._onRouteInfoChanged.bind(this), 500))
        );

        this._cabinetCmpnt.on(
            "ExplorerChanged",
            (this._onExplorerChanged = this._onExplorerChanged.bind(this))
        );
    }

    _unregisterDeviceExplorerListeners() {
        if (this._solutionManager) {
            this._solutionManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
        }
        if (this._userSession) {
            this._userSession.removeListener("OrganizationChange", this._onOrganizationChange);
        }
        // Make sure this code fires before editorTab close triggers
        if (this._editorLayout) {
            this._editorLayout.removeListener("EditorClosed", this._onEditorClosed);
            this._editorLayout.removeListener("ActiveTabChanged", this._onActiveTabChanged);
        }
        if (Steve.router) {
            Steve.router.removeListener("RouteDetailsChanged", this._onRouteInfoChanged);
        }
        if (this._cabinetCmpnt) {
            this._cabinetCmpnt.removeListener("ExplorerChanged", this._onExplorerChanged);
        }
    }

    launchOdmOsPlatformEditor(editorState, launchOpts) {
        const platformIds = _.concat(launchOpts.ids || [], launchOpts.id || []);
        const stringToHash = platformIds.join("_");
        launchOpts = _.omit(launchOpts, ["id", "ids"]);

        //console.log('launch device editor: ', deviceIds); //22411 - debug
        this.generateHash(stringToHash)
            .catch((error) => this._logger.warn({error}))
            .then((tabId) => {
                launchOpts = _.assign({}, launchOpts, {
                    id: tabId,
                    platformIds: platformIds,
                });

                return this._editorLayout
                    .launchEditor(editorState, Registrations.ODM_OS_PLATFORM_EDITOR, launchOpts)
                    .then(() => {
                        this.emit("EditorLaunched", editorState, launchOpts);
                        return Promise.resolve();
                    });
            });
    }

    updateFilter(filterString) {
        if (_.isEmpty(filterString)) {
            this._reestablishFeed();
        } else {
            this._reestablishFeed(filterString);
        }
    }

    generateHash(stringToHash) {
        // Check if crypto.subtle is available
        if (!window.crypto || !window.crypto.subtle) {
            // Fallback to a simple hash function if crypto.subtle is not available
            return Promise.resolve(this._fallbackHash(stringToHash));
        }

        try {
            const encoder = new TextEncoder();
            const data = encoder.encode(stringToHash);

            return window.crypto.subtle
                .digest("SHA-256", data)
                .then(hexString)
                .catch((error) => {
                    console.warn("Crypto digest failed, falling back to simple hash:", error);
                    return this._fallbackHash(stringToHash);
                });
        } catch (error) {
            console.warn("Error in generateHash, falling back to simple hash:", error);
            return Promise.resolve(this._fallbackHash(stringToHash));
        }

        function hexString(buffer) {
            const byteArray = new Uint8Array(buffer);
            const hexCodes = [...byteArray].map((value) => {
                const hexCode = Number(value).toString(16);
                return hexCode.padStart(2, "0");
            });
            return hexCodes.join("");
        }
    }

    _fallbackHash(str) {
        // Simple fallback hash function for environments without crypto.subtle
        let hash = 0;
        if (str.length === 0) {
            return hash.toString(16);
        }

        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32-bit integer
        }

        return Math.abs(hash).toString(16);
    }

    onGridColumnUpdated() {
        this.runQuickConfirmationActionWorkflow(
            {
                message: "Column definitions have been changed. Do you want to refresh the page?",
                title: "Update Confirmation Check",
                confirmDetails: {
                    text: "Yes",
                    type: "text",
                },
            },
            (this.onGridUpdateAction = this.onGridUpdateAction.bind(this))
        );
    }

    onGridUpdateAction() {
        return this.renderer.render();
    }

    whenInitialized() {
        return Promise.resolve()
            .then(() => {
                this._activeOrgId = this._userSession.activeOrganization.id;
                return;
            })
            .then(() => this._licenseRestriction.whenLicenseFeedIsReady())
            .then(() => {
                return this._OsUpgradePlanPrefsEntity.loadPrefs(this._activeOrgId);
            })
            .then((OsUpgradePlanPrefs) => {
                this._isCatalogEnable = _.get(OsUpgradePlanPrefs, "enableCatalogs");
                if (!this._isCatalogEnable) {
                    this.hideBarView(Registrations.PLATFORM_EXPLORER_SWITCH_TO_OS_CATALOG);
                    this._LMRBLayout.state.bottom.removePart(
                        Registrations.OS_CATALOG_EXPLORER_LMRB
                    );
                } else {
                    let nonActivePartsIds =
                        this._LMRBLayout.state.bottom.getNonActiveAvailablePartsIds();

                    if (
                        nonActivePartsIds.find(
                            (partId) => partId === Registrations.OS_CATALOG_EXPLORER_LMRB
                        )
                    ) {
                        this._LMRBLayout.state.bottom.addPart(
                            Registrations.OS_CATALOG_EXPLORER_LMRB,
                            Registrations.OS_CATALOG_EXPLORER_LMRB
                        );
                    }
                }
                return;
            })
            .then(() => {
                if (!Steve.controlAppNav.xDomeEnabled) {
                    this.hideBarView(Registrations.SITE_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER);
                    this._LMRBLayout.state.bottom.removePart(
                        Registrations.IOT_DEVICE_EXPLORER_ENTITY_LMRB
                    );
                }
                return;
            });
    }

    /**
     * On a first visit, reopen previously opened solution
     */
    _switchSolution(view = "") {
        if (
            this.currentSolutionName === "config_drift" ||
            this.currentSolutionName === "os_manager" ||
            this.currentSolutionName === "data_explorer" ||
            this.currentSolutionName === "device_manager"
        ) {
            let currentExplorerView = this._gameEditorData.getData("currentExplorerView");
            if (!_.isEmpty(view)) {
                currentExplorerView = view;
            }
            this._gameEditorData.setData(currentExplorerView, "currentExplorerViewTemp");
            if (
                currentExplorerView &&
                currentExplorerView === Registrations.AUDIT_POLICY_EXPLORER_LMRB
            ) {
                this.openLMRBExplorer(Registrations.AUDIT_POLICY_EXPLORER_LMRB);
                /*} else if (currentExplorerView && currentExplorerView === Registrations.OS_CATALOG_EXPLORER_LMRB && this._isCatalogEnable) {
                this.openLMRBExplorer(Registrations.OS_CATALOG_EXPLORER_LMRB);*/
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.DATA_EXPLORER_LMRB
            ) {
                this.openLMRBExplorer(Registrations.DATA_EXPLORER_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.SITE_EXPLORER_ENTITY_LMRB
            ) {
                this.openLMRBExplorer(Registrations.SITE_EXPLORER_ENTITY_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.NETWORK_DISCOVERY_EXPLORER_ENTITY_LMRB
            ) {
                this.openLMRBExplorer(Registrations.NETWORK_DISCOVERY_EXPLORER_ENTITY_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.DEVICE_EXPLORER_ENTITY_LMRB
            ) {
                this.openLMRBExplorer(Registrations.DEVICE_EXPLORER_ENTITY_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.CONFIG_DRIFT_DEVICE_EXPLORER_ENTITY_LMRB
            ) {
                this.openLMRBExplorer(Registrations.CONFIG_DRIFT_DEVICE_EXPLORER_ENTITY_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.DATA_EXPLORER_DEVICE_EXPLORER_ENTITY_LMRB
            ) {
                this.openLMRBExplorer(Registrations.DATA_EXPLORER_DEVICE_EXPLORER_ENTITY_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB
            ) {
                this.openLMRBExplorer(Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.OS_PLAN_EXPLORER_LMRB
            ) {
                this.openLMRBExplorer(Registrations.OS_PLAN_EXPLORER_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.IOT_OS_PLAN_EXPLORER_LMRB
            ) {
                this.openLMRBExplorer(Registrations.IOT_OS_PLAN_EXPLORER_LMRB);
            } else {
                this._cabinetCmpnt.selectView(Registrations.PLATFORM_EXPLORER_GRID);
            }
            return;
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    get isOSMSolutionAvailable() {
        return this._isOSMSolutionAvailable;
    }

    set isOSMSolutionAvailable(isAvailable) {
        this._isOSMSolutionAvailable = isAvailable;
    }

    get osImageServers() {
        return this._osImageServers;
    }

    get sitePaths() {
        return this._sitePaths;
    }

    get isBackupActionAvailable() {
        return _.get(this._userSession, "authorizedActions").indexOf("deviceBackupRun") > -1;
    }

    get hasRestorePerms() {
        return _.get(this._userSession, "authorizedActions").indexOf("deviceRestoreRun") > -1;
    }

    get hasGroupRestorePerms() {
        // replace with group restore permission
        return (
            _.get(this._userSession, "authorizedActions").indexOf("multipleDeviceRestoreRun") > -1
        );
    }

    get isRestoreActionAvailable() {
        return this.hasGroupRestorePerms;
    }

    get hasSupportDataRun() {
        return _.get(this._userSession, "authorizedActions").indexOf("deviceSupportDataRun") > -1;
    }

    get hasDeviceSupportDataRead() {
        return _.get(this._userSession, "authorizedActions").indexOf("deviceSupportDataRead") > -1;
    }

    get isDataSyncActionAvailable() {
        return _.get(this._userSession, "authorizedActions").indexOf("dataSyncRun") > -1;
    }

    get isDataConfigWriteAvailable() {
        return _.get(this._userSession, "authorizedActions").indexOf("dataConfigWrite") > -1;
    }

    /** @deprecated use osImageServerMain */
    get osImageServerMaster() {
        return this.osImageServerMain;
    }
    get osImageServerMain() {
        return this.osImageServerList.find((osImageServer) => osImageServer.isMain);
    }

    get isOsUpgradeAutoCaptured() {
        return _.get(this._autoCapturePrefsEntity.getOwnOrgEvents(), "deviceOsUpgrade", false);
    }

    get isOsTransferAutoCaptured() {
        return _.get(this._autoCapturePrefsEntity.getOwnOrgEvents(), "deviceOsTransfer", false);
    }

    shutdown() {
        this._unregisterDeviceExplorerListeners();
        let shutdowns = [
            //_.invoke(this._statusBar, "shutdown")
            _.isUndefined(this._siteFeed) ? Promise.resolve() : this._siteFeed.shutdown(),
        ];
        return Promise.all(shutdowns).then(
            () => {
                this._userSession = undefined;
                this._editorLayout = undefined;
                this._DeviceEntityDef = undefined;
                this._SiteEntityDef = undefined;
                this._OsUpgradePlanPrefsEntity = undefined;
                this._licenseRestriction = undefined;
                this._isCatalogEnable = undefined;
                this._filterFromUrl = undefined;
                this._autoCapturePrefs = undefined;
                this._vendorMap = undefined;
                this._typeBaseMap = undefined;
                this._autoCapturePrefsEntity = undefined;
                this._sitePaths = undefined;
                this._osImageServers = undefined;
                this._valueMap = undefined;
                this._hasSupportedOs = undefined;
                return super.shutdown();
            },
            (err) => {
                this._logger.warn(
                    {error: err},
                    "PlatformExplorerEntityLmrbComponent.shutdown() error"
                );
            }
        );
    }

    /*******************************************/
    /* START HANDLER METHODS                   */
    /*******************************************/
    _onSolutionChanged(/*newActiveSolution*/) {
        // Case 22070 -- removing the condition and shutting down always
        // if (
        //     newActiveSolution.lmrbNamespaces &&
        //     newActiveSolution.lmrbNamespaces.includes(Registrations.DEVICE_EXPLORER_ENTITY_LMRB)
        // ) {
        //     this._updateNameSpaces(true);
        //     this.renderer.render();
        // } else {
        this.shutdown();
        // }
    }

    _onOrganizationChange(newOrg, oldOrg) {
        this.emit("OrganizationChanged");
        this._unregisterDeviceExplorerListeners();
        if (!_.isUndefined(newOrg) && !_.isUndefined(oldOrg) && newOrg.id !== oldOrg.id) {
            this._updateNameSpaces(true);
            this.renderer.render().then(() => {
                this._registerDeviceExplorerListeners();
            });
        }
    }

    _onEditorClosed(tabId, editorParams) {
        this.emit("EditorClosed", tabId, editorParams);
    }

    _onActiveTabChanged(tabId, editorParams) {
        this.emit("ActiveTabChanged", tabId, editorParams);
    }

    _onRouteInfoChanged() {
        if (event && event.oldURL !== event.newURL) {
            this._xDomeEnabled = Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled;
            const currentView = this._whereToRedirect();
            if (
                currentView &&
                this._gameEditorData.getData("currentExplorerViewTemp") !== currentView
            ) {
                this._gameEditorData.setData(currentView, "currentExplorerViewTemp");
                this._gameEditorData.setData(currentView, "currentExplorerView");
                this._cabinetCmpnt.emit("ExplorerChanged");
                this.openLMRBExplorer(currentView);
            }
        }
    }

    _onExplorerChanged() {
        this.shutdown();
    }

    _onInstanceRemovedFromFeed(instance, cause) {
        // console.log(instance, cause);
        if (cause === "Deleted") {
            this._feedUpdated(instance);
        }
    }
}

module.exports = PlatformExplorerEntityLmrbComponent;

PlatformExplorerEntityLmrbComponent.$inject = [
    "$teve.logger",
    "$teve.di",
    "EditorLayout.EditorLayout",
    "$teve.userSession",
    "$teve.licenseRestriction",
    "$teve.storageFactory",
    "$teve.solutionsManager",
    "$teve.entities.OsUpgradePlanPrefs",
];
PlatformExplorerEntityLmrbComponent.$supportedQuadrants = ["bottom"];
PlatformExplorerEntityLmrbComponent.$defaultQuadrants = ["bottom"];
PlatformExplorerEntityLmrbComponent.$iconRepoName = "osmanager.odm_os_platform_explorer";
PlatformExplorerEntityLmrbComponent.$displayName = "IoT Platform Explorer";
